import { to } from '@react-spring/web';

export const interpolateXY = (props) =>
  to([props.x, props.y], (x, y) => `translate3d(${x}px, ${y}px, 0)`);

export const handleYToTranslateInterpolation = (v) => `translateY(${v}px) translateZ(0)`;
export const handleXToTranslateInterpolation = (v) => `translateX(${v}px) translateZ(0)`;
export const handleScaleToTranslateInterpolation = (v) => `scale(${v}) translateZ(0)`;
